import React, { useCallback, useMemo, useState, memo, useContext, useEffect } from "react"
import { Link } from "gatsby"
import { useFormContext } from "react-hook-form";
import { AboutCar, About, Pricing } from "./overlayViews";
import Spacer from '../components/spacer'
import { StageContext } from "./context/formContext";


const Overlay = () => {

  const { stage, setStage } = useContext(StageContext)

  const close = useCallback(() => {
    setStage(0)
    document.querySelector('.overlay--form').classList.remove('active');
  }, [setStage])



  const stages = useMemo(() => ([
    {
      name: 'Choose an option',
      prompt: `Choose an option to get started.`,
      Component: Pricing
    },
    {
      name: 'Tell us about you',
      prompt: `Tell us about you!`,
      Component: About
    },
    {
      name: 'Tell us about your car',
      prompt: `Tell us about your car!`,
      Component: AboutCar
    },
    {
      name: 'Submitted',
      prompt: `Thanks! We’ve recieved your enquiry and will contact you within 24hrs.`,
      Component: () => null
    },
  ]), [])

  return (
    <div className='overlay--form '>
      <div className='header p20 flex align-center'>
        <Link to="/">
          <div className='main--logo'></div>
        </Link>
        <div className="close mla">
          <div className="close--overlay" onClick={close} role='presentation'></div>
        </div>
      </div>
      <FormStages close={close} stage={stage} setStage={setStage} stages={stages} />
    </div>
  )
}

const FormStages = memo(({ stages, stage, setStage, close }) => {

  const [errorMessage, setErrorMessage] = useState('')
  const [fatalError, setFatalError] = useState('')
  const { register, setValue, getValues, setError, getFieldState, watch, control, handleSubmit, formState } = useFormContext();

  const { errors, isSubmitted } = formState


  const onClick = useCallback((name) => {
    setStage((state) => {
      if (state === 0 && !getValues('pricing')) {
        return state
      }

      return name(state)
    })
  }, [getValues, setStage])

  const isErrored = useCallback((name) => {
    if ((name.invalid) || (isSubmitted && name.invalid)) {
      return 'error'
    }
    return ''
  }, [isSubmitted])

  React.useEffect(() => {
    const subscription = watch((value, { name, type }) => console.log(value, name, type));
    return () => subscription.unsubscribe();
  }, [watch]);



  const currentStage = stage

  const encode = (data) => {
    const formData = new FormData();

    for (const key of Object.keys(data)) {

      if (typeof data[key] === 'object') {
        formData.append(key, data[key][0]);
      } else {
        formData.append(key, data[key]);
      }
    }

    return formData;
  }


  const showErrorMessage = useCallback((show) => {
    if (show) {
      setErrorMessage('Please fill out the fields highlighted in red.')
    } else {
      setErrorMessage('')
    }
  }, [setErrorMessage])

  const submit = useCallback(async (data, e) => {
    try {
      const formData = encode({
        "form-name": 'contact',
        ...data
      })
      const res = await fetch('/', {
        method: "POST",
        body: formData
      })
      console.log(res)

      onClick((state) => state + 1)
      if (res.status > 299) {
        throw new Error('not found')
      }


    } catch (e) {
      setFatalError("An error occured, please refresh and try again or contact us at ben@swiftcarsales.com.au")

      console.error(e)
    }
  }, [onClick])



  const watchedFieldState = useCallback((name) => {
    return getFieldState(name, formState)
  }, [formState, getFieldState])


  const validateInputs = useCallback((names) => {

    const valid = names.filter((name) => {
      const input = getFieldState(name)
      if (!input.isDirty && !input.invalid) {
        setError(name, { type: 'validate', message: '' });
      }
      return (!input.invalid && input.isDirty)
    })
    return valid.length === names.length
  }, [getFieldState, setError])


  const nextStage = useCallback((e) => {
    if (e.preventDefault) {
      e.preventDefault()
    }
    onClick((state) => {
      switch (state) {
        case 1:
          if (!validateInputs(['name', 'lastName', 'phoneNumber', 'email', 'location'])) {
            showErrorMessage(true)
            return state
          }
          showErrorMessage(false)
          return state + 1
        case 2:
          if (!validateInputs(['make', 'model', 'year', 'odometer', 'badge'])) {
            showErrorMessage(true)
            return state
          }
          showErrorMessage(false)
          return state + 1
        default:
          break;
      }
      showErrorMessage(false)
      return state + 1
    })
  }, [onClick, validateInputs, showErrorMessage])


  useEffect(() => {
    if (document.querySelector('.overlay--form')) {
      document.querySelector('.overlay--form').scrollTop = 0
    }
  }, [stage])


  useEffect(() => {
    const name = stages[stage].name
    if (window.gtag) {
      window.gtag("event", "change_form_stage", { name })
      if (name === "Submitted") {
        window?.gtag("event", "sign_up")
      }
    }
  }, [stage, stages])

  const prevStage = useCallback((e) => {
    if (e.preventDefault) {
      e.preventDefault()
    }
    onClick((state) => state - 1)
  }, [onClick])

  const nav = useCallback((e, index) => {
    if (e.preventDefault) {
      e?.preventDefault()
    }
    onClick((state) => {
      if (index < state) {
        return index
      }
      switch (state) {
        case 1:
          if (!validateInputs(['name', 'lastName', 'phoneNumber', 'email', 'location'])) {
            showErrorMessage(true)
            return state
          }
          showErrorMessage(false)
          return index
        case 2:
          if (!validateInputs(['make', 'model', 'year', 'odometer', 'badge'])) {
            showErrorMessage(true)
            return state
          }
          showErrorMessage(false)
          return index
        default:
          break;
      }
      showErrorMessage(false)
      return index
    })

  }, [onClick, showErrorMessage, validateInputs])

  return (
    <form name="contact" method="POST" encType="multipart/form-data" data-netlify="true" onSubmit={handleSubmit(submit)} className='form--stages p20'>
      <input type="hidden" name="form-name" value="contact" />
      <p className='h2 mla mra m0 max-650 text-center mt40 mb40 min-h-300 flex flex-col justify-center'>{fatalError ? fatalError : stages[stage]?.prompt}</p>
      {(stage === stages.length - 1) ? <div className="pt40 flex justify-center flex-col">
        <button onClick={close} className='button ma b0' ><span>Return to Homepage</span></button>
        <Spacer />
      </div> : null}
      <div className='form--nav text-center  w-100 flex justify-center medium'>
        <div className="flex justify-between w-100 max-800 m-hide ">
          <div className="form--nav-line" />
          {stages.map((stage, index) => {
            const name = stage.name
            if (index === stages.length - 1) {
              return null
            }
            return <Navigation key={index} className={(index <= currentStage ? 'active ' : '')} name={name} onClick={(e) => nav(e, index)} />
          })}
        </div>
      </div>
      {stages.map(({ name, Component }, index) => {
        return (
          <FormStage key={index} className={(stage === index ? 'active' : '')} title={name}>
            <Component isErrored={isErrored} getFieldState={watchedFieldState} errors={errors} control={control} action={nextStage} setValue={setValue} register={register} />
            {(index !== 0 && index !== stages.length - 1) ? <Controller errorMessage={errorMessage} next={nextStage} prev={prevStage} stage={stage} total={stages.length} /> : null}
          </FormStage>
        )
      })}

    </form>
  )
})

const Controller = memo(({ stage, total, next, prev, errorMessage }) => {

  return (
    <div className="flex justify-between w-100 max-1200 ma align-center pt40 m-flex-col-r m-align-start m-pt20 ">
      <div className="flex m-flex-col-r ">
        <p className="m0  m-pt20 mr20 m-mr0 m-mb10 ">Step {stage + 1} of {total - 1}</p>
        <p style={{ color: 'red' }} className="m0 ">{errorMessage}</p>
      </div>

      <div className="flex flex-grow-1 justify-end m-pb10">
        <button onClick={prev} className="button prev-button unset-button  ">
          Previous
        </button>
        <NextOrSubmit next={next} submit={(stage === total - 2)} />
      </div>
    </div>
  )
})

const NextOrSubmit = memo(({ submit, next }) => {
  if (submit) {
    return (
      <button type="submit" className="next-button  button">
        <span> Submit</span>
      </button>
    )
  } else {
    return (
      <button onClick={next} className="next-button  button">
        <span>Next</span>
      </button>
    )
  }
})

const FormStage = memo(({ children, className }) => {
  return (
    <div className={'form--stage mh-100a ' + className}>
      <div className="internal mla mra">
        <div className="pt40 mt40 ma m-pt0 m-mt0 ">
          {children}
        </div>
      </div>
    </div>
  )
})

const Navigation = memo(({ name, onClick, className }) => {
  return (
    <button className={"unset-button stage form--nav " + className} onClick={onClick} >
      <div className='pointer-none'>
        <div className="icon mla mra mb40 flex flex justify-center align-center">
          <div className="stage-tick-wrapper ">
            <div className="stage-tick" />
          </div>
        </div>
        <p className='m0 nav--title'>{name}</p>
      </div>
    </button>
  )
})


export default Overlay